import { render, staticRenderFns } from "./qdCom.vue?vue&type=template&id=258196f5&scoped=true"
import script from "./qdCom.vue?vue&type=script&lang=js"
export * from "./qdCom.vue?vue&type=script&lang=js"
import style0 from "./qdCom.vue?vue&type=style&index=0&id=258196f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258196f5",
  null
  
)

export default component.exports